export const getFavoriteList = /* GraphQL */ `
  query GetFavoriteList(
    $loginName: String!
    $tenantLandscape: ModelFavoriteUserFavoritesCompositeKeyConditionInput
  ) {
    listFavorites: userFavorites(
      loginName: $loginName
      tenantLandscape: $tenantLandscape
    ) {
      items {
        menuId
        sort
      }
    }
  }
`;
